import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { UseSpkFarmDataResult } from '../../../data/useSpkFarmData'
import { Token } from '@/domain/types/Token'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'

const SECONDS_PER_YEAR = 60 * 60 * 24 * 365

export interface CreateTxOverviewParams {
  formValues: TransferFromUserFormNormalizedData
  spkFarmData: UseSpkFarmDataResult
}

export type TxOverview =
  | { status: 'no-overview' }
  | {
      status: 'success'
      apy: Percentage
      stakingToken: Token
      rewardToken: Token
      rewardsPerYear: NormalizedNumber
      outcome: {
        token: Token
        value: NormalizedNumber
        usdValue: NormalizedNumber
      }
    }

export function createTxOverview({ formValues, spkFarmData }: CreateTxOverviewParams): TxOverview {
  const value = formValues.value
  if (value.eq(0)) {
    return { status: 'no-overview' }
  }

  const stakedAmountUsd = formValues.token.toUSD(formValues.value)
  const rewardsPerYear = stakedAmountUsd
    .times(spkFarmData.rewardRate)
    .div(spkFarmData.totalSupply.plus(formValues.value))
    .times(SECONDS_PER_YEAR)
  const rewardsPerYearUsd = spkFarmData.rewardToken.toUSD(rewardsPerYear)
  const apy = stakedAmountUsd.gt(0)
    ? Percentage(rewardsPerYearUsd.div(stakedAmountUsd), { allowMoreThan1: true })
    : Percentage(0)

  const stakingTokenAmount = formValues.token.toUSD(formValues.value).div(spkFarmData.stakingToken.unitPriceUsd)
  const outcome = {
    token: spkFarmData.stakingToken,
    usdValue: stakedAmountUsd,
    value: stakingTokenAmount,
  }

  return {
    status: 'success',
    apy,
    stakingToken: spkFarmData.stakingToken,
    rewardToken: spkFarmData.rewardToken,
    rewardsPerYear,
    outcome,
  }
}
